function normalizeSegmentValue(value) {
  return (value || '')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

function applyProductSegmentVisibility(scope) {
  var rootNodes = (scope || document).querySelectorAll('[data-product-segment-root]');

  if (!rootNodes.length) return;

  var params = new URLSearchParams(window.location.search);
  var segmentKey = normalizeSegmentValue(params.get('segment'));

  rootNodes.forEach(function (root) {
    var panels = Array.from(root.querySelectorAll('[data-segment-panel]'));

    // Hide all panels first
    panels.forEach(function (panel) {
      panel.hidden = true;
    });

    if (!segmentKey) {
      root.style.display = 'none';
      return;
    }

    var activePanel = panels.find(function (panel) {
      return normalizeSegmentValue(panel.getAttribute('data-segment-panel')) === segmentKey;
    });

    // Only show if active panel exists AND has actual content
    if (activePanel && activePanel.textContent.trim()) {
      activePanel.hidden = false;
      root.style.display = '';
    } else {
      root.style.display = 'none';
    }
  });
}

function initProductSegmentVisibility() {
  applyProductSegmentVisibility(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSegmentVisibility);
} else {
  initProductSegmentVisibility();
}

document.addEventListener('shopify:section:load', function (event) {
  applyProductSegmentVisibility(event.target);
});

document.addEventListener('shopify:section:reorder', initProductSegmentVisibility);

document.addEventListener('shopify:section:select', function (event) {
  applyProductSegmentVisibility(event.target);
});
